module.exports = __webpack_public_path__ + "static/media/preview_chart_2_Revenue.396dbd23.PNG";